import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@babel+core@7.26.7_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@babel+core@7.26.7_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/png_files/Environment.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svg/clipboard.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svg/layout-grid.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svg/loader.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svg/user.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Home/FeaturedCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Home/PopularProductGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Home/UniverseOfStyle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/LandingPage/LandingPage.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/Button.tsx");
